import { deviceApi } from './device'

export const deviceServe = {
  ...deviceApi,
}
